import './index.css';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { registerHarmoneyPortalIcons } from './components/harmoneyportalicon';
import MainPageModel from './modules/mainpagemodel';
import {
	setRootModuleState,
	getQueryString,
	webapi,
	DateUtils,
	REPORTED_EXCEPTION
} from 'ps-gui';
import { registerModules } from './modules/moduleregistration';
import {
	checkLogoutImminentIn,
	clearLogoutImminent,
	initializeSession,
	setLoggedOut
} from './data/session';
import { processException } from './data/exceptions';
import { initializeLookups } from './data/lookup';
import { GlobalContextModel } from './data/globalcontext';
import { pushState } from './data/history';

DateUtils.setRawDateToJSON();

let baseUrl;
function initBaseUrl() {
	function getBase() {
		if (window.location.origin.indexOf('localhost') > 0) {
			return 'http://asdev02.raventia.net:8088/sojuz-portal-rest-dev2';
			//return 'http://localhost:8080/sojuz-portal-rest';
		} else if (window.location.origin.indexOf('desktop-r1i49f1') > 0) {
			return 'http://localhost:8080/sojuz-portal-rest';
		}
		const pathName = window.location.pathname || '';
		if (pathName.indexOf('test2') > 0) {
			return '/sojuz-portal-rest-test2';
		} else if (pathName.indexOf('dev2') > 0) {
			return '/sojuz-portal-rest-dev2';
		} else {
			return '/sojuz-portal-rest';
		}
	}
	baseUrl = getBase();
}

initBaseUrl();

function getDefaultLanguage() {
	const res = localStorage.getItem('languageId');
	if (res) {
		return res;
	}
	const langs = window.navigator.languages || [];
	if (langs.some(lng => {
		lng = lng.toLowerCase();
		return lng.indexOf('cs') >= 0 || lng.indexOf('cz') >= 0 || lng.indexOf('sk') >= 0;
	})) {
		return 'CZ';
	} else {
		return 'EN';
	}
}

async function setDefaultLanguage() {
	let gc = new GlobalContextModel();
	gc = await gc.setLanguageId(getDefaultLanguage());
	gc.apply();
}

webapi.setDecorateUrl(url => {
	return baseUrl + url;
}).setDefaultMethod('post');

webapi.setProcessException(processException);

webapi.addListener(url => {
	if (url && url.indexOf('lanu_') < 0) {
		clearLogoutImminent();
		checkLogoutImminentIn(60);
	}
});

registerHarmoneyPortalIcons();
registerModules();

async function loginToken2SessionToken(token) {
	let res = await webapi.execute('/api/proc/api_user/getPartyLoginSession', {
		token
	});
	if (res === REPORTED_EXCEPTION) {
		return null;
	}
	return res.token;
}

const DUMMY_PAGE = false;
async function run() {
	window.basePath = window.location.origin + window.location.pathname;
	await setDefaultLanguage();
	ReactDOM.render(<App />, document.getElementById('root'));

	if (DUMMY_PAGE) {
		const origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		setLoggedOut();
		setRootModuleState(new MainPageModel().getState());
		return;
	}

	if (getQueryString('ua')) {
		return;
	}

	const st = getQueryString('st');
	const loginToken = getQueryString('s');
	let sessionToken = null;
	if (st) {
		sessionToken = st;
	} else if (loginToken) {
		const origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		console.log(origPathName);
		sessionToken = await loginToken2SessionToken(loginToken);
	} else {
		const origPathName = window.location.pathname;
		document.getElementById('favicon').setAttribute('href', origPathName + 'favicon.png');
		window.history.replaceState('home', '', '/');
		console.log('origPathName = ', origPathName);
		// window.history.replaceState('home', '', '/');
	}
	pushState('home', '');
	await initializeSession(sessionToken);
	await initializeLookups();

	let rootModel = new MainPageModel();
	setRootModuleState(rootModel.getState());

}


run();

if (module.hot) {
	module.hot.accept();
}

window.webapi = webapi;

window.addEventListener('dragenter', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
}, false);

window.addEventListener('dragover', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
});

window.addEventListener('drop', function (e) {
	if (!e.defaultPrevented) {
		e.preventDefault();
		e.dataTransfer.effectAllowed = 'none';
		e.dataTransfer.dropEffect = 'none';
	}
});
